import { render, staticRenderFns } from "./Inicio.vue?vue&type=template&id=4d8e04b4&scoped=true&"
import script from "./Inicio.vue?vue&type=script&lang=ts&"
export * from "./Inicio.vue?vue&type=script&lang=ts&"
import style0 from "./Inicio.vue?vue&type=style&index=0&id=4d8e04b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8e04b4",
  null
  
)

export default component.exports